import { render } from "./ImageViewerDialog.vue?vue&type=template&id=1658d456&scoped=true"
import script from "./ImageViewerDialog.vue?vue&type=script&lang=ts"
export * from "./ImageViewerDialog.vue?vue&type=script&lang=ts"

import "./ImageViewerDialog.vue?vue&type=style&index=0&id=1658d456&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1658d456"

export default script